import styled from 'styled-components';
import { Button, Tooltip, colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4Small } from 'components/common/election/cards/constants';
import { SubscriberProductLineType } from 'types/electionService';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';

interface ProductLineCardStyledProps {
  $isInvalid?: boolean;
  $pLineType?: SubscriberProductLineType;
}

export const ProductLineCardStyled = styled.li<ProductLineCardStyledProps>`
  display: grid;

  /* The first row uses 1fr to layout cards.
   In some cases, this row displays a message instead of the dependent list. */
  grid-template-rows: 1fr auto;
  border-radius: 6px;
  box-shadow: ${boxShadows.dark[4]};

  ${({ $isInvalid, $pLineType }): string => {
    if ($isInvalid) {
      return `
        background-color: ${colors.red[100]};
        border: 0.1rem solid ${colors.red[300]};
      `;
    }

    switch ($pLineType) {
      case 'SELECTED':
        return `
          background-color: ${colors.blue[100]};
          border: 0.1rem solid ${colors.blue[300]};
        `;
      case 'WAIVED':
        return `
          background-color: ${colors.neutral[100]};
          border: 0.1rem solid ${colors.neutral[300]};
        `;
      case 'NOT_SELECTED':
      default:
        return `
          background-color: ${colors.neutral.white};
          border: 0.1rem solid ${colors.blue[300]};
        `;
    }
  }}
`;

// Info Section
export const InfoSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1.5rem;
`;

export const TooltipStyled = styled(Tooltip)`
  /* Override default positioning to bring the Select and Tooltip closer */
  top: 110%;

  /* Helps keep tooltip not wider than the product select */
  white-space: unset;
`;

// Rate Section
export const RateSectionStyled = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background-color: ${colors.neutral.white};
  border-top: 1px solid ${colors.neutral[300]};
  border-radius: 0 0 6px 6px;
  min-height: 2.4rem;

  ${breakpointsMQ4Small} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const RateTitleStyled = styled.span`
  ${typography.bold[14]}
  color: ${colors.neutral[900]};
`;

export const RateStyled = styled.span<{ $isInvalid?: boolean }>`
  color: ${({ $isInvalid }): string => ($isInvalid ? colors.red[600] : colors.green[600])};
  ${typography.bold[14]}
`;

export const RateActionButtonStyled = styled(Button)`
  padding: 0;
  font-size: 1.3rem;

  span {
    padding-right: 0.5rem;
  }
`;
